import { useAITeacher } from "../../../../hooks";
import { useEffect, useRef, useState } from "react";
import { Icon, Button } from "semantic-ui-react";
export const MessagesList = () => {
  const {
    messages,
    playMessage,
    stopMessage,
    currentMessage,
    classroom,
    playAudio,
    setIsDisplayingText,
    EndTextMessage,
  } = useAITeacher();

  const container = useRef(null);

  const [displayedText, setDisplayedText] = useState("");

  useEffect(() => {
    if (messages.length > 0 && currentMessage && playAudio) {
      const lastMessage = messages[messages.length - 1];
      // Compare the current message with the last one rendered
      if (currentMessage.id === lastMessage.id) {
        let text = "";
        // console.log("paso 1");
        // Primero, verifica si lastMessage.answer[0] existe y no es undefined
        if (
          lastMessage.answer.sms !== undefined &&
          typeof lastMessage.answer.sms === "string"
        ) {
          text = lastMessage.answer.sms;
          // console.log("paso 2", text);
        } else {
          text = "No hay mensaje";
        }
        let index = 0;
        setDisplayedText(text[0]);
        EndTextMessage(true);
        const intervalId = setInterval(() => {
          if (index < text.length - 1) {
            index++;
            setDisplayedText((prev) => prev + text[index]);
          } else {
            clearInterval(intervalId);
            EndTextMessage(false);
          }
        }, 65); // Adjust speed here

        return () => clearInterval(intervalId);
      }
    }
  }, [messages, currentMessage, EndTextMessage, playAudio]);

  useEffect(() => {
    if (container.current) {
      container.current.scrollTo({
        top: container.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [displayedText]);

  const formatText = (text) => {
    return text
      .replace(/(?:\r\n|\r|\n)/g, "<br />") // Reemplaza los saltos de línea con <br />
      .replace(/-\s+/g, "<br />- ") // Reemplaza guiones seguidos de espacios con <br /> seguido por el guión
      .replace(/(\d+\.)/g, "<br />$1") // Reemplaza números seguidos de puntos con <br /> seguido por el número
      .replace(/\*/g, ""); // Elimina todos los asteriscos
  };

  const renderFormattedText = (htmlText) => (
    <p
      className="text-7xl inline-block px-2 rounded-sm font-bold bg-clip-text text-transparent bg-gradient-to-br from-blue-300/90 to-white/90"
      dangerouslySetInnerHTML={{ __html: formatText(htmlText) }}
    />
  );
  const scrollTextUp = () => {
    if (container.current) {
      container.current.scrollBy({
        top: -100, // Desplaza 100px hacia arriba
        behavior: "smooth",
      });
    }
  };

  const scrollTextDown = () => {
    if (container.current) {
      container.current.scrollBy({
        top: 100, // Desplaza 100px hacia abajo
        behavior: "smooth",
      });
    }
  };

  const lastMessage = messages[messages.length - 1];
  //console.log("lastMessage", lastMessage);

  return (
    <div
      className={`${
        classroom === "default"
          ? "w-[1288px] h-[676px]"
          : "w-[2528px] h-[856px]"
      } p-8 overflow-y-auto flex flex-col space-y-8 bg-transparent opacity-80`}
      ref={container}
    >
      {messages.length === 0 ? (
        <div className="h-full w-full grid place-content-center text-center">
          <h2 className="text-8xl font-bold text-white/90 italic">
            EDUCA360
            <br />
            Tecnología y metodología en la educación
          </h2>
        </div>
      ) : (
        <div>
          <div className="flex justify-between items-center">
            <div className="flex-grow">
              <div className="flex items-center gap-3">
                {renderFormattedText(displayedText)}
              </div>
            </div>
            {setIsDisplayingText && playAudio ? (
              <Button
                icon
                className="ml-10 p-8 bg-red-500 rounded text-white"
                onClick={() => stopMessage(lastMessage)}
                style={{
                  position: "absolute", // o 'fixed' si quieres que permanezca en posición durante el desplazamiento
                  right: "-150px", // Distancia desde el borde derecho de la pantalla
                  top: "20px", // Distancia desde el borde superior para alinear verticalmente
                  width: "100px",
                  height: "100px",
                }}
              >
                <Icon name="stop" size="big" />
              </Button>
            ) : (
              <Button
                icon
                className="ml-10 p-8 bg-green-500 rounded text-white"
                onClick={() => playMessage(lastMessage)}
                style={{
                  position: "absolute", // o 'fixed' si quieres que permanezca en posición durante el desplazamiento
                  right: "-150px", // Distancia desde el borde derecho de la pantalla
                  top: "20px", // Distancia desde el borde superior para alinear verticalmente
                  width: "100px",
                  height: "100px",
                }}
              >
                <Icon name="play" size="big" />
              </Button>
            )}
            <Button
              icon
              className="ml-10 p-8 bg-blue-500 rounded text-white"
              onClick={scrollTextUp}
              style={{
                position: "absolute",
                right: "-150px",
                top: "260px", // Posición debajo del botón de play
                width: "100px",
                height: "100px",
              }}
            >
              <Icon name="arrow up" size="big" />
            </Button>
            <Button
              icon
              className="ml-10 p-8 bg-blue-500 rounded text-white"
              onClick={scrollTextDown}
              style={{
                position: "absolute",
                right: "-150px",
                top: "380px", // Posición debajo del botón de subir
                width: "100px",
                height: "100px",
              }}
            >
              <Icon name="arrow down" size="big" />
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
